let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9LFwE")).then(() => parcelRequire('e45EX'));